import {useEffect, useState} from 'react';
import {useGetLoggedInUserQuery} from "@mwServices/User";

const useIsLoggedIn = () => {
    const loggedInQuery = useGetLoggedInUserQuery();
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(!!(loggedInQuery && loggedInQuery.data && loggedInQuery.data.user));

    useEffect(() => {
        let check = false;
        if(!!(loggedInQuery && loggedInQuery.data && loggedInQuery.data.user)){
            check = true;
        }
        if(check !== isLoggedIn)  setIsLoggedIn(check);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedInQuery.data])

    return isLoggedIn;
}

export default useIsLoggedIn;